import { useContext } from "react";
import DownloadIcon from "../../../../assets/img/card-icons/descargar.svg";
import { PrescriptionContextMemorySpace } from "../../../../contexts/prescription/prescriptionContext";
import usePagination from "../hooks/usePagination";
import useDownload from "../hooks/useDownload";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { toSentenceCase } from "../../../../utils/capitalize";

const Desktop = () => {
  const { anterior, siguiente } = usePagination();
  const { descargar } = useDownload();
  const { activeKey, resultsTemp, total, loader, offset, setOffset } = useContext(
    PrescriptionContextMemorySpace
  );

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  function formatDate(value) {
    value = value?.split("T")[0];
    const chunks = value.split("-");
    const format = `${chunks[2]}-${chunks[1]}-${chunks[0]}`;
    return format;
  }

  const itemsPerPage = 5;
  const totalPages = Math.ceil(total / itemsPerPage);

  const handlePageChange = (event, page) => {
    const newOffset = (page - 1) * itemsPerPage;
    setOffset(newOffset);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* SEPARADOR */}
      <div
        className="separador-table-red-result"
        id="separator-top-results"
      ></div>
      {/* TABLA */}
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="table-responsive" style={{ height: "315px" }}>
            {!loader ? (
              <table className="table table-hb" id="tablePrescriptions">
                <thead>
                  <tr>
                    {resultsTemp?.length > 0 && (
                      <>
                        <th>Id</th>
                        <th>Válida desde</th>
                        <th>Droga</th>
                        <th>Presentación</th>
                        <th>Cantidad</th>
                        {activeKey < 2 && <th>Acciones</th>}
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {resultsTemp?.length > 0 ? (
                    resultsTemp.map((result, i) => {
                      return (
                        <tr key={i}>
                          <td>{result.id.replace(/^0+/, "")}</td>
                          <td>{formatDate(result.validFrom)}</td>
                          <td>{toSentenceCase(result.droga)}</td>
                          <td>{toSentenceCase(result.presentation)}</td>
                          <td>{result.quantity}</td>
                          {activeKey < 2 && (
                            <td>
                              <img
                                onClick={() => descargar(result)}
                                className="i-25-result"
                                src={DownloadIcon}
                                alt="..."
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <td
                      colSpan="5"
                      style={{
                        textAlign: "center",
                        paddingBottom: "15px",
                        paddingTop: "15px",
                      }}
                    >
                      <p
                        className="section_hb_title"
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        No se encontraron resultados con esas opciones de
                        búsqueda.
                        <br /> Intente con otros parámetros, o contáctese con
                        nuestro equipo de{" "}
                        <a
                          href="mailto:soportewebhb@hbritanico.com.ar"
                          className="section_hb_title"
                          style={{
                            fontSize: "16px",
                            textDecoration: "underline",
                          }}
                        >
                          Soporte
                        </a>
                        .
                      </p>
                    </td>
                  )}
                </tbody>
              </table>
            ) : (
              <div className="text-center" style={{ paddingBottom: "15px" }}>
                <span className="spinner-grow spinner-grow-sm"></span>
                <span className="spinner-grow spinner-grow-sm"></span>
                <span className="spinner-grow spinner-grow-sm"></span>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* SEPARADOR */}
      <div className="separador-table-red-result"></div>
      {total > 0 && resultsTemp.length > 0 && (
        <div className="row">
          <div className="col-12 d-flex justify-content-center my-3">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={offset / itemsPerPage + 1}
                onChange={handlePageChange}
                showFirstButton={total > 5}
                showLastButton={total > 5}
                hidePrevButton={totalPages === 1}
                hideNextButton={totalPages === 1}
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root.Mui-selected': {
                    backgroundColor: '#E0E0E0', // gris claro
                    color: '#000', // texto negro
                    '&:hover': {
                      backgroundColor: '#d5d5d5',
                    },
                  },
                }}
              />
            </Stack>
          </div>
        </div>
      )}
      {/* offset: {offset} - total: {total} - resultsTemp: {resultsTemp.length}  - filteredResults: {filteredResults.length} */}
    </>
  );
};

export default Desktop;
